import { render, staticRenderFns } from "./SelectCompensation.vue?vue&type=template&id=5b928954"
import script from "./SelectCompensation.vue?vue&type=script&lang=js"
export * from "./SelectCompensation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports